import { Set } from "immutable";
import * as reportActions from "lib/api/rideReports";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import appStyles from "../../App/appStyles.scss";
import { SponsorFooter } from "../VotePage/VoteBody";
import styles from "./Showcase.scss";
import { ShowcaseCard, ShowcaseCardContainer } from "./ShowcaseCard";

export class Showcase extends React.Component {
  componentDidMount() {
    const { weeklyWinnerIds, finalistIds } = this.props.rolloutContest;
    // using set as dedupe: crude but effective
    const ids = Set(weeklyWinnerIds.concat(finalistIds)).filter((id) => !this.props.reports.has(id));
    if (ids.size > 0) {
      this.props.loadReportsById(ids);
    }
  }

  render() {
    const { reports } = this.props;
    const { weeklyWinnerIds } = this.props.rolloutContest;

    const grandPrizeWinnerId = 2066;
    const finalistIds = [1082, 2129, 2137, 1258, 1213, 2084, 1165, 1659, 1328];

    return (
      <div className={styles.Showcase}>
        <Helmet title="2017 Ride Report Rollout Contest" />
        <div className={styles.topFlex}>
          <div className={styles.text}>
            <h1 className={appStyles.pageTitle}>Ride Report Rollout</h1>
            <p>
              For the launch of our Ride Reports feature in the spring of 2017, we asked our users to go on rides that
              challenged and inspired them, then share those rides with the community in the form of a Ride Report.
              Prizes up for grabs included tons of great PDW swag, three sets of handbuilt Sugar wheels, and a
              fully-custom Breadwinner B-Road gravel bike!
            </p>
            <p>
              Out of the hundreds of submissions, these prize-winning reports stood out for their compelling stories,
              top-notch photography, and adventurous source material. We hope you enjoy reading them!
            </p>
          </div>
          <div className={styles.img}>
            <img src="/images/ride_reports_rollout/rr_logo_3.png" />
          </div>
        </div>

        <h2>Grand Prize</h2>
        <ShowcaseCardContainer>
          {reports.get(grandPrizeWinnerId) && <ShowcaseCard report={reports.get(grandPrizeWinnerId)} />}
        </ShowcaseCardContainer>
        <h2>Finalists</h2>
        <ShowcaseCardContainer>
          {finalistIds
            .map((id) => reports.get(id))
            .filter((v) => v)
            .map((r) => (
              <ShowcaseCard key={r.id} report={r} />
            ))}
        </ShowcaseCardContainer>

        <h2>Weekly Winners</h2>
        <ShowcaseCardContainer>
          {weeklyWinnerIds
            .map((id) => reports.get(id))
            .filter((v) => v)
            .map((r) => (
              <ShowcaseCard key={r.id} report={r} />
            ))}
        </ShowcaseCardContainer>
        <SponsorFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  reports: state.rideReports.reports,
  rolloutContest: state.rolloutContest,
});

const mapDispatchToProps = {
  loadReportsById: reportActions.loadReportsById,
};

export const ShowcaseContainer = connect(mapStateToProps, mapDispatchToProps)(Showcase);
